<script lang="ts">
  import { Capacitor } from "@capacitor/core";
  import { storage, translate } from "lib";
  import { dialogData } from "stores";
  import { ButtonComponent } from "ui";

  let data;
  const platform = Capacitor.getPlatform();

  const closeDialog = (): void => {
    $dialogData.data = {};
    $dialogData.type = "";
  };

  const onSkip = async (): Promise<void> => {
    await storage.set("ignoreUpdate", new Date().toISOString());
    closeDialog();
  };

  const onUpdate = (): void => {
    const url = platform === "android"
      ? "https://play.google.com/store/apps/details?id=online.strongman.app"
      : "https://apps.apple.com/us/app/strongman-online-method/id1528506183";

    window.open(url, "_system");
    closeDialog();
  };

  export { data };
</script>

<div class="p-4 flex flex-col gap-4 leading-none">
  <div class="font-bold text-center text-xxl">
    {translate("UPDATE_AVAILABLE")}
  </div>

  <div class="text-center">
    {translate("CURRENT_VERSION")}:
    <span class="font-bold">{data.currentVersion}</span>
    <br />
    {translate("NEWEST_VERSION")}:
    <span class="font-bold">{data.latestVersion}</span>
  </div>

  <div class="text-justify">{translate("UPDATE_TO_USE_APP")}</div>

  <div class="flex justify-center gap-4">

    <ButtonComponent isOutline on:click={onSkip}>
      {translate("SKIP")}
    </ButtonComponent>

    <ButtonComponent isOutline on:click={onUpdate}>
      {#if platform === "ios"}
        <img class="h-8" src="app-store.webp" alt="App store" />
      {:else if platform === "android"}
        <img class="h-8" src="play-store.webp" alt="Play store" />
      {/if}
      {translate("UPDATE")}
    </ButtonComponent>

  </div>
</div>
